import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de oleos Adjuvantes
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function OleosAdjuvantes(props) {
  useEffect(() => {
    const title = 'oleosAdjuvantes.oleosAdjuvantes';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.OLEOS_ADJUVANTES}
      insumoURL='oleos'
      viewKey='oleosAdjuvantes'
      deleteMessageSucess={formatMessage(
        'oleosAdjuvantes.oleosAdjuvantesRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('oleosAdjuvantes.falhaAoExcluirOleosAdjuvantes')}
      mensagemDelete={formatMessage('oleosAdjuvantes.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'oleosAdjuvantes';
  })[0].content
});

export default connect(mapStateToProps)(OleosAdjuvantes);
